import ClipboardJS from 'clipboard';

let copyele: HTMLDivElement;

export function copy(value: string): Promise<void> {
  if (!copyele) {
    copyele = document.createElement('div');
    copyele.style.display = 'none';
    copyele.className = 'clipboard-copy-input';
    document.body.appendChild(copyele);
  }
  const clipboard = new ClipboardJS(copyele);
  return new Promise((resolve, reject) => {
    clipboard.on('success', () => {
      resolve();
    });
    clipboard.on('error', () => {
      reject();
    });
    copyele.setAttribute('data-clipboard-text', value);
    // 因为是指向同一个 ele，dom 同步需要时间
    setTimeout(() => copyele.click(), 300);
  });
}
